import React from 'react'
import TextField from '@material-ui/core/TextField'
import InputAdornment from '@material-ui/core/InputAdornment'
import YumCopyButton from '../YumCopyButton/YumCopyButton'

interface YumReadOnlyFieldProps {
  label: string
  value: string
  showCopy?: boolean
}

let yumReadOnlyFieldIdCounter = 0

export default function YumReadOnlyField({ label, value, showCopy = true }: YumReadOnlyFieldProps) {
  // Stable auto-id so MUI's InputLabel binds htmlFor → input id. Without it,
  // axe's `label` rule fails on these readonly copy-target inputs.
  const idRef = React.useRef<string | null>(null)
  if (!idRef.current) {
    yumReadOnlyFieldIdCounter += 1
    idRef.current = `yum-readonly-${yumReadOnlyFieldIdCounter}`
  }
  return (
    <TextField
      variant="filled"
      margin="dense"
      fullWidth
      id={idRef.current}
      label={label}
      value={value}
      InputProps={{
        readOnly: true,
        disableUnderline: true,
        style: { fontFamily: 'monospace', fontSize: '0.8125rem' },
        endAdornment:
          showCopy && value ? (
            <InputAdornment position="end">
              <YumCopyButton text={value} />
            </InputAdornment>
          ) : undefined,
      }}
      InputLabelProps={{
        shrink: true,
      }}
    />
  )
}
